'use client'

import { type ReactNode } from 'react'
import { createContext, useContext, useState } from 'react'

type PageCSSClassContextValue = {
  pageClass: string
  setPageClass: (className: string) => void
}

const PageCSSClassContext = createContext<PageCSSClassContextValue>({
  pageClass: '',
  setPageClass: () => {},
})

export function PageCSSClassProvider({ children }: { children: ReactNode }) {
  const [pageClass, setPageClass] = useState('')
  return <PageCSSClassContext.Provider value={{ pageClass, setPageClass }}>{children}</PageCSSClassContext.Provider>
}

export function usePageCSSClass() {
  return useContext(PageCSSClassContext)
}
